import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var LinkContext = /*#__PURE__*/React.createContext(); // See: https://www.gatsbyjs.org/docs/gatsby-link/#reminder-use-link-only-for-internal-links

function defaultIsLinkInternal(href) {
  return /^\/(?!\/)/.test(href);
}
function LinkProvider(_ref) {
  var InternalLink = _ref.InternalLink,
    _ref$isLinkInternal = _ref.isLinkInternal,
    isLinkInternal = _ref$isLinkInternal === void 0 ? defaultIsLinkInternal : _ref$isLinkInternal,
    children = _ref.children;
  return ___EmotionJSX(LinkContext.Provider, {
    value: {
      InternalLink: InternalLink,
      isLinkInternal: isLinkInternal
    }
  }, children);
}
LinkProvider.propTypes = {
  InternalLink: PropTypes.elementType,
  isLinkInternal: PropTypes.func,
  children: PropTypes.node.isRequired
};
export default LinkProvider;